module.exports = __webpack_public_path__ + "img/guide-icon.aa77981c.svg";